import { useCallback, useRef } from 'react';

export const useSelectScrollIntoView = () => {
  const selectRef = useRef<{ select: { controlRef: HTMLDivElement } }>(null);

  const onMenuOpen = useCallback(() => {
    setTimeout(() => {
      selectRef.current?.select?.controlRef?.scrollIntoView({
        block: 'start',
        behavior: 'smooth',
      });
    });
  }, []);

  return { ref: selectRef, onMenuOpen };
};
